module.exports = __webpack_public_path__ + "assets/language.a84ceaa6.svg";